import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ForgotPassword, LoginUser, LoginUserFromThirdParty, RecoverPassword, RegisterUser, SendOTPRegister, VerifyOTP, VerifyOTPResponse,ChangePassword } from "../api/loginApi";

export const loginSessionAsync = createAsyncThunk(
  "Login",
  async (formValue) => {
    const response = await LoginUser(formValue);
    // toastMessage(response.status, response.result);
    return response;
  }
);

export const ThirdPartyloginSessionAsync = createAsyncThunk(
  "Third Party Login",
  async (formValue) => {
    const response = await LoginUserFromThirdParty(formValue);
    // toastMessage(response.status, response.result);/   


    
    return response;
  } 
);

export const SendOTPRegisterAsync = createAsyncThunk(
  "SendOTP",
  async (formValue) => {
    const response = await SendOTPRegister(formValue);
    return response;
  }
);
export const ChangePasswordAsync = createAsyncThunk(
  "ChangePassword",
  async (formValue) => {
    const response = await ChangePassword(formValue);
    return response;
  }
);

export const VerifyOTPRegisterAsync = createAsyncThunk(
  "VerifyOTP",
  async (formValue) => {
    const response = await VerifyOTPResponse(formValue);
    return response;
  }
);

export const RegisterUserAsync = createAsyncThunk(
  "RegisterUser",
  async (formValue) => {
    const response = await RegisterUser(formValue);
    return response;
  }
);

export const ForgotPasswordAsync = createAsyncThunk(
  "Forgot Password",
  async (formValue) => {
    const response = await ForgotPassword(formValue);
    return response;
  }
);

export const VerifyOTPAsync = createAsyncThunk(
  "Verify OTP",
  async (formValue) => {
    const response = await VerifyOTP(formValue);
    return response;
  }
);

export const RecoverPasswordAsync = createAsyncThunk(
  "Change Password",
  async (formValue) => {
    const response = await RecoverPassword(formValue);
    return response;
  }
);

const loginSlice = createSlice({
  name: "Login",
  initialState: [],
  reducers: {},
  extraReducers: (builder) => {},
});

export default loginSlice.reducer;
